import {
  foodsActions as actions,
  ChangeRecommendations,
} from '@/entities/foods';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import * as UI from '@/shared/ui';
import React, { useCallback } from 'react';

import { SingleRecommendation } from './SingleRec';

export const Recommendations = () => {
  const dispatch = useAppDispatch();
  const recs = useAppSelector((state) => state.foods.form.recs);

  const onDelete = useCallback((id: number) => {
    dispatch(actions.deleteRec(id));
  }, []);

  const onSwap = useCallback((index: number, destIndex: number) => {
    dispatch(actions.onSwapRecs({ index, destIndex }));
  }, []);

  const onChange = useCallback((data: ChangeRecommendations) => {
    const { index, key, value } = data;
    dispatch(actions.changeRecs({ index, key, value }));
  }, []);
  return (
    <UI.Block>
      <fieldset className='mb-[40px] flex w-[100%] items-center justify-between'>
        <h1 className={'text-[42px] font-medium leading-[48px] text-black'}>
          Рекомендации
        </h1>
      </fieldset>
      <div className='flex flex-col items-center gap-[32px]'>
        {recs.map((elem: any, i) => (
          <SingleRecommendation
            {...elem}
            index={i}
            itemsCount={recs.length}
            onSwap={onSwap}
            onChange={onChange}
            onDelete={onDelete}
            key={elem.id}
          />
        ))}
        <button
          data-testid={'button-add_rule'}
          className={
            'self-center text-[18px] leading-[24px] text-blue200 transition-all duration-150 hover:text-blue300'
          }
          type='button'
          onClick={() => dispatch(actions.addRecs())}
        >
          Добавить еще
        </button>
      </div>
    </UI.Block>
  );
};
